import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DataManager, Query, ODataV4Adaptor, Predicate } from '@syncfusion/ej2-data';
import { SaveEventArgs, EditSettingsModel, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { environment } from 'src/environments/environment';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-whatsapp',
  templateUrl: './whatsapp.component.html',
  styleUrls: ['./whatsapp.component.scss']
})
export class WhatsappComponent implements OnInit{
  @Input() relatedTypeId!: number;
  @Input() recordId!: number;

  @ViewChild('navTemplate', { static: true }) navTemplate: any;
  title = "Whatsapp";
  data!: DataManager;
  query!: Query;
  baseUrl: string = environment.baseUrl.replace('/api/', '/odata/');
  editSettings: EditSettingsModel =  { allowAdding: true, mode: 'Dialog' };
  toolbar: string[] = [];
  columns!: object[];
  public pageOptions: PageSettingsModel =  { pageSize: 25, pageSizes: [25, 50, 100], pageCount: 5 };
  public submitClicked: boolean = false;
  public formData!: UntypedFormGroup;
  currentUser: any

  relatedData!: object[];
  relatedQuery!: Query;
  relatedMobiles!:object[];
  selectedMobile!:any;
  selectedContact!:string;

  constructor(private authService: AuthenticationService, private formBuilder: UntypedFormBuilder) { }

  ngOnInit(): void {
    this.currentUser = this.authService.currentUserValue;
    this.columns = [
      { field: 'Id', isPrimaryKey: false, template: this.navTemplate },
    ]

    if(this.relatedTypeId == 1){
      this.relatedQuery = new Query().where('Id', 'equal', this.recordId);
      new DataManager({
        url: this.baseUrl + "lead",
        adaptor: new ODataV4Adaptor(),
        headers: [{ 'Authorization': 'Bearer ' + this.currentUser.token }]
      }).executeQuery(this.relatedQuery).then((e: any) => {
        this.relatedMobiles = []; 
        if (e.result.length > 0) {
          const contact = e.result[0];
          if (contact.ContactDetail) {
            this.relatedMobiles.push({ 'Name': contact.Name, "Number": contact.ContactDetail });
          }
          if (contact.Mobile1) {
            this.relatedMobiles.push({ 'Name': contact.Name, "Number": contact.Mobile1 });
          }
        }
      });
    }
    else{
      this.relatedQuery = new Query().where('AccountId', 'equal', this.recordId);
      new DataManager({
        url: this.baseUrl + "ContactPerson",
        adaptor: new ODataV4Adaptor(),
        headers: [{ 'Authorization': 'Bearer ' + this.currentUser.token }]
      }).executeQuery(this.relatedQuery).then((e: any) => {
        this.relatedMobiles = [];
        e.result.forEach((contact: any) => {
          if (contact.Mobile1) {
            this.relatedMobiles.push({ 'Name': contact.Name, "Number": contact.Mobile1 });
          }
          if (contact.Mobile2) {
            this.relatedMobiles.push({ 'Name': contact.Name, "Number": contact.Mobile2 });
          }
          if (contact.WhatsApp) {
            this.relatedMobiles.push({ 'Name': contact.Name, "Number": contact.WhatsApp });
          }
        });
      });
    }
  }
  
  onChange(args: any): void{
    if(args.itemData)
    {      
  
      this.selectedMobile  = this.formatMobileNumber(args.itemData.Number);
      this.selectedContact = args.itemData.Name;
  
    }else
    {
      this.selectedMobile  = null;
      this.selectedContact = null;
    }
    this.data = new DataManager({
      url: this.baseUrl + "WhatsappChat",
      adaptor: new ODataV4Adaptor(),
      headers: [{ 'Authorization': 'Bearer ' + this.currentUser.token }]
    });
    let predicate: Predicate = new Predicate('FromNumber', 'equal', this.selectedMobile)
    .or('ToNumber', 'equal', this.selectedMobile);
    this.query = new Query().where(predicate).sortByDesc('Date');

  }

  actionBegin(args: SaveEventArgs): void {
    // let objData: any = args.rowData;
    // if (args.requestType === 'beginEdit' || args.requestType === 'add') {
    //   this.submitClicked = false;

    //   this.formData = this.formBuilder.group({
    //     Id: [objData.Id ? objData.Id : 0],
    //     Comment: [objData.Name, [Validators.required]],
    //     RelatedTypeId: [objData.RelatedTypeId ? objData.RelatedTypeId : this.relatedTypeId],
    //     RelatedId: [objData.RelatedId ? objData.RelatedId : this.recordId],
    //   });
    // }
    // if (args.requestType === 'save') {
    //   this.submitClicked = true;
    //   if (this.formData.valid) {
    //     args.data = this.formData.value;
    //   } else {
    //     args.cancel = true;
    //   }
    // }
  }

  actionComplete(args): void {
    // if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {

    //   if (args.requestType === 'add') {
    //     (args.form.elements.namedItem('Name') as HTMLInputElement).focus();
    //     args.dialog.header = 'Enter your comment here';
    //   }
    // }
    // if (args.requestType === 'save') {
    //   this.submitClicked = true;
    //   if (this.formData.valid) {
    //     args.data = this.formData.value;
    //   } else {
    //     args.cancel = true;
    //   }
    // }
  }

  get f() {
    return this.formData.controls;
  }
  
  formatMobileNumber(mobileNumber: string): string {
    // Remove any leading '0'
    if (mobileNumber.startsWith('0')) {
      mobileNumber = mobileNumber.substring(1);
    }
  
    // Check if the number is exactly 10 digits long
    if (mobileNumber.length === 10) {
      return '91' + mobileNumber;
    }
  
    // If the number starts with '91', ensure it's 12 digits long
    if (mobileNumber.startsWith('91') && mobileNumber.length === 12) {
      return '' + mobileNumber;
    }
  
    // Return the number as is if it doesn't fit any of the above conditions
    return mobileNumber;
  }
}
